module.exports = __webpack_public_path__ + "img/icon_header_avatar-default.487a9111.svg";